/**
 * Axeptio CMP utility functions
 */

declare global {
  interface Window {
    axeptioSDK?: any;
    openAxeptioCookies?: () => void;
    _axcb?: Array<(sdk: any) => void>;
  }
}

/**
 * Opens the Axeptio cookies management widget
 */
export const openAxeptioCookies = (): void => {
  if (typeof window === 'undefined') return;

  // Use SDK instance (Axeptio does not set window.openAxeptioCookies)
  if (window.axeptioSDK && typeof window.axeptioSDK.openCookies === 'function') {
    window.axeptioSDK.openCookies();
    return;
  }

  // Fallback: queue for when SDK loads
  window._axcb = window._axcb || [];
  window._axcb.push(function(sdk: any) {
    if (sdk && typeof sdk.openCookies === 'function') {
      sdk.openCookies();
    }
  });
};

/**
 * Checks if Axeptio SDK is loaded
 */
export const isAxeptioLoaded = (): boolean => {
  return typeof window !== 'undefined' &&
         !!(window.axeptioSDK && typeof window.axeptioSDK.openCookies === 'function');
};

// The shadow root lives on the first child of #axeptio_overlay (div.needsclick),
// not on #axeptio_overlay itself — confirmed via console inspection.
const hideAxeptioButton = (): void => {
  const overlay = document.getElementById('axeptio_overlay');
  if (!overlay) return;
  const shadowHost = overlay.children[0];
  if (!shadowHost?.shadowRoot) return;
  const btn = shadowHost.shadowRoot.querySelector<HTMLElement>('#axeptio_main_button');
  if (btn) btn.style.setProperty('display', 'none', 'important');
};

/**
 * Hides the Axeptio floating re-open button after the user has given consent.
 * The initial consent modal is left untouched (CNIL compliant).
 * Withdrawal is available via the "Préférences cookies" link in the footer.
 */
export const hideAxeptioButtonAfterConsent = (): void => {
  if (typeof window === 'undefined') return;

  const subscribe = (sdk: any): void => {
    // Returning visitor: button renders on load — hide after Axeptio finishes mounting
    setTimeout(hideAxeptioButton, 600);

    // New visitor: hide after they complete the consent modal
    if (typeof sdk?.on === 'function') {
      sdk.on('cookies:complete', () => setTimeout(hideAxeptioButton, 200));
    }
  };

  if (window.axeptioSDK) {
    subscribe(window.axeptioSDK);
  } else {
    window._axcb = window._axcb || [];
    window._axcb.push(subscribe);
  }
};
